module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('div', {
    staticClass: "my-4 display-1"
  }, [_vm._v("Android aplikacija")]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Trenutna verzija aplikacije " + _vm._s(_vm.appVersion))]), _vm._v(" "), (_vm.configuration.android.forceUpdate) ? _c('div', {
    staticClass: "headline"
  }, [_vm._v("Neophodno je instalirati novu verziju aplikacije")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "my-5",
    attrs: {
      "href": _vm.configuration.android.applicationUrl,
      "large": "",
      "block": "",
      "outline": ""
    }
  }, [_vm._v("preuzmi")])], 1)], 1)], 1)
},staticRenderFns: []}